export default __webpack_public_path__ + "static/media/upee_animation.46cf6e5b.mp4";